const { logLevels, stringify } = require('../helpers');

/**
 * @typedef {import('../helpers')} LogLevel
 */

let memoryLog = '';
/**
 *
 * @param {object[]} message(s)
 * @param {object} [userContext]
 * @param {LogLevel} logLevel Level to log message with
 */
function output(message, userContext, logLevel) {
    switch (logLevel) {
        case logLevels.ERROR:
            memoryLog += 'ERROR: ';
            break;
        case logLevels.WARN:
            memoryLog += 'WARNING: ';
            break;
        case logLevels.INFO:
            memoryLog += 'INFO: ';
            break;
        case logLevels.DEBUG:
            memoryLog += 'DEBUG: ';
            break;
    }
    memoryLog += message.map(m => stringify(m)).join(' ') + '\n';
}

function getMemoryLog() {
    return memoryLog;
}

function clearMemoryLog() {
    memoryLog = '';
}

module.exports = {
    output,
    getMemoryLog,
    clearMemoryLog
};
